import Base from './Base';

export default class Keyword extends Base {
    get stats() {
        const total_subscribers = this.statistics.total.total_subscribers;
        const unsubscribed = this.statistics.total.unsubscribed;
        const subscribers = this.statistics.total.subscribers;
        const total_subscribers_percent = (100 / total_subscribers) * total_subscribers;
        const unsubscribed_percent = (100 / total_subscribers) * unsubscribed;
        const subscribers_percent = (100 / total_subscribers) * subscribers;

        return {
            total_subscribers: total_subscribers,
            total_subscribers_percent: total_subscribers ? total_subscribers_percent : 0,
            unsubscribed: unsubscribed,
            unsubscribed_percent: total_subscribers ? unsubscribed_percent : 0,
            subscribers: subscribers,
            subscribers_percent: total_subscribers ? subscribers_percent : 0,
        };
    }

    get tooltip() {
        const numbers = this.numbers.map(number => number.formatted_number).join(', ');

        return `Text <strong>${this.name}</strong> to <strong>${numbers}</strong> to test the keyword.`;
    }

    get isDisabled() {
        return Boolean(this.disabled_at);
    }

    get isActive() {
        return Boolean(this.is_active);
    }

    get totalSubscribers() {
        return this.stats.total_subscribers;
    }

    get totalSubscribedPercent() {
        return this.stats.total_subscribers_percent === 100 ? this.stats.total_subscribers_percent : this.stats.total_subscribers_percent.toFixed(1);
    }

    get unsubscribed() {
        return this.stats.unsubscribed;
    }

    get unsubscribedPercent() {
        return this.stats.unsubscribed_percent === 100 ? this.stats.unsubscribed_percent : this.stats.unsubscribed_percent.toFixed(1);
    }

    get subscribers() {
        return this.stats.subscribers;
    }

    get subscribersPercent() {
        return this.stats.subscribers_percent === 100 ? this.stats.subscribers_percent : this.stats.subscribers_percent.toFixed(1);
    }
}
